import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import WrappedApp from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WrappedApp />
  </React.StrictMode>
);
